// Simple pub/sub for updating header quota UI from anywhere (e.g. ChatPage).
// 只做前端数量减/加，不重新请求后端配额接口。

const listeners = new Set();

/**
 * 监听配额变动（通常是减 1）。
 * 回调参数为 delta（可正可负，默认 -1）。
 */
export function onQuotaDelta(callback) {
  if (typeof callback !== 'function') {
    return () => {};
  }
  listeners.add(callback);
  return () => listeners.delete(callback);
}

/**
 * 触发配额变动事件，默认 delta = -1（消耗一次算力）。
 */
export function emitQuotaDelta(delta = -1) {
  listeners.forEach((listener) => {
    try {
      listener(delta);
    } catch (error) {
      console.error('Quota delta listener error:', error);
    }
  });
}

